import React from 'react';
import { Flex, RowActionButton, Initials } from '@mss/mss-component-library';
import { Tooltip } from 'antd';
import { TFunction } from 'i18next';
import dateFormat from 'dateformat';
import { Copy, Info } from 'react-feather';

const columns = (t: TFunction, openDetailModal: (x: any) => void) => [
  {
    title: '',
    dataIndex: 'user',
    key: '',
    width: 30,
    render: (user_name: any) => (
      <Flex h="center" v="center">
        <Initials name={user_name} />
      </Flex>
    ),
  },
  {
    title: t('Actor'),
    dataIndex: 'user',
    key: 'user',
    width: 165,
    sorter: () => 0,
    render: (user_name: any, record: any) => (
      <Flex v="center">
        <div>
          <p className={'mb-0'}>{user_name}</p>
          <small className={'text-gray-500'}>{record.ip_address}</small>
          <Tooltip title={record.user_agent}>
            <Info className="ml-1 text-gray-500" size={12} />
          </Tooltip>
        </div>
      </Flex>
    ),
  },
  {
    title: t('Category'),
    dataIndex: 'category_name',
    key: 'category',
    width: 165,
  },
  {
    title: t('Activity'),
    dataIndex: 'activity_name',
    key: 'activity',
    width: 165,
  },
  {
    title: t('Object'),
    dataIndex: 'object_repr',
    key: 'object_id',
    sorter: () => 0,
    render: (object_repr: any, record: any) => (
      <>
        <div>
          <p className={'mb-0'}>{object_repr}</p>
          {record.object_values?.asset_repr && (
            <small className={'text-gray-500'}>
              {record.object_values.asset_repr}
            </small>
          )}
        </div>
      </>
    ),
  },
  {
    title: t('Date & Time'),
    dataIndex: 'created_at',
    key: 'created_at',
    width: 165,
    sorter: () => 0,
    render: (record: any) =>
      record && dateFormat(record || '', 'mmmm dS, yyyy @ h:MM:ss TT'),
  },
  {
    title: '',
    dataIndex: '',
    key: 'actions',
    width: 40,
    render: (record: any) => {
      return (
        record.changed_values && (
          <Flex onClick={e => e.stopPropagation()}>
            <Tooltip title={t('Show details')}>
              <RowActionButton
                onClick={() => openDetailModal(record)}
                shape="circle"
                style={{ border: 'none', backgroundColor: 'transparent' }}
              >
                <Copy size={18} className="text-gray-500" />
              </RowActionButton>
            </Tooltip>
          </Flex>
        )
      );
    },
  },
];

export default columns;
